import React from 'react';
import { Typography, Box } from '@mui/material';
import { Avatar, Grid } from '@mui/joy';
import { useThemeContext } from '../../context/ThemeContext';

const PopularCategorys = () => {
    const { isSM, isMD, isMd, isLg } = useThemeContext();

    const categories = [
        { id: 1, name: 'Manager' },
        { id: 2, name: 'Manager' },
        { id: 3, name: 'Manager' },
        { id: 4, name: 'Manager' },
        { id: 5, name: 'Manager' },
        { id: 6, name: 'Manager' },
        { id: 7, name: 'Manager' },
        { id: 8, name: 'Manager' },
        { id: 9, name: 'Manager' },
        { id: 10, name: 'Manager' },
        { id: 11, name: 'Manager' },
    ];

    return (
        <Box sx={{ width: '1153px', m: '20px auto' }}>
            <Box>
                <Typography variant="h4"
                    sx={{ FontSize: '35px', color: '#28A745', fontWeight: 700, lineHeight: '43.88px', textAlign: 'center' }}>
                    Popular Category
                </Typography>
            </Box>


            <Grid container sx={{ mt: 4 }}>
                {categories.slice(0, 4).map((category) => (
                    <Grid item xs={12} sm={6} md={3} key={category.id} sx={{ maxHeight: '100%', }}>
                        <Box sx={{
                            position: 'relative',
                            width: '224px',
                            margin: 'auto'
                        }}>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '224px',
                                height: '224px',
                                border: '2px solid #28A745',
                                borderRadius: '100%',
                            }}>
                                <Avatar
                                    alt={`category-${category.id}`}
                                    src={`assets/images/Mask group (${category.id}).png`}
                                    sx={{
                                        width: 204,
                                        height: 204,

                                    }}
                                />
                            </Box>
                            <Box sx={{ textAlign: 'center', mt: 1 }}>
                                <Typography sx={{
                                    fontWeight: 600,
                                    color: '#026309',
                                    textTransform: 'capitalize'
                                }}>
                                    {category.name}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>


            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', gap: 10 }}>
                {categories.slice(4, 7).map((category) => (

                    <Box key={category.id} sx={{
                        position: 'relative',
                        margin: '20px 0',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '224px',
                            height: '224px',
                            border: '2px solid #28A745',
                            borderRadius: '100%',
                        }}>
                            <Avatar
                                alt={`category-${category.id}`}
                                src={`assets/images/Mask group (${category.id}).png`}
                                sx={{
                                    width: 204,
                                    height: 204,

                                }}
                            />
                        </Box>
                        <Box sx={{ textAlign: 'center', mt: 1 }}>
                            <Typography sx={{
                                fontWeight: 600,
                                color: '#026309',
                                textTransform: 'capitalize'
                            }}>
                                {category.name}
                            </Typography>
                        </Box>
                    </Box>

                ))}
            </Box>


            <Grid container>
                {categories.slice(7).map((category) => (
                    <Grid item xs={12} sm={6} md={3} key={category.id}>
                        <Box sx={{
                            position: 'relative',
                            width: '224px',
                            margin: 'auto'
                        }}>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '224px',
                                height: '224px',
                                border: '2px solid #28A745',
                                borderRadius: '100%',
                            }}>
                                <Avatar
                                    alt={`category-${category.id}`}
                                    src={`assets/images/Mask group (${category.id}).png`}
                                    sx={{
                                        width: 204,
                                        height: 204,

                                    }}
                                />
                            </Box>
                            <Box sx={{ textAlign: 'center', mt: 1 }}>
                                <Typography sx={{
                                    fontWeight: 600,
                                    color: '#026309',
                                    textTransform: 'capitalize'
                                }}>
                                    {category.name}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box >
    );
};

export default PopularCategorys;
